import React from 'react';
import { Badge, Button } from 'react-bootstrap';

type HeaderAction = {
  id: string;
  label: string;
  onClick: () => void;
  variant?: string;
  disabled?: boolean;
};

interface ProjectPageHeaderProps {
  title: string;
  subtitle: string;
  contextLabel?: string;
  contextBadge?: string;
  actions?: HeaderAction[];
}

const ProjectPageHeader: React.FC<ProjectPageHeaderProps> = ({
  title,
  subtitle,
  contextLabel,
  contextBadge,
  actions = [],
}) => (
  <header className="project-page-header dashboard-hero mb-3">
    <div className="dashboard-header d-flex justify-content-between align-items-center">
      <div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <h2 className="dashboard-title mb-0">{title}</h2>
          {contextBadge && <Badge bg="primary-subtle" text="primary">{contextBadge}</Badge>}
        </div>
        <p className="text-muted mb-0 small">{subtitle}</p>
        {contextLabel && (
          <div className="dashboard-live-meta small">
            <span className="dashboard-live-dot" aria-hidden />
            <span>{contextLabel}</span>
          </div>
        )}
      </div>
      {!!actions.length && (
        <div className="project-header-actions">
          {actions.map((action) => (
            <Button
              key={action.id}
              variant={action.variant || 'primary'}
              onClick={action.onClick}
              disabled={Boolean(action.disabled)}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  </header>
);

export default ProjectPageHeader;
